/* eslint-disable no-nested-ternary */
import axios from 'axios';
import { Desafios_Cursos, Estudiantes } from 'generated/graphql';
import { useQuery } from 'react-query';
import { IRubricaSegData } from 'redux/reducersV2/displayRubricaSegSlice';

export function useGetEstudiante({
	estudianteKey,
	enabled = true,
	desafioCursoKey,
	cacheBust = false,
	// isHistorialSeg,
	isSeguimiento,
	grupoKeyNoMember,
	isRubrica
}: {
	estudianteKey: string;
	enabled?: boolean;
	desafioCursoKey?: string;
	cacheBust?: boolean;
	// isHistorialSeg?: boolean;
	isSeguimiento?: {
		isSeguimiento: boolean;
		rutaKey: string;
		cursoKey: string;
		tipoActividad: string;
		numeroSesion: number;
		numeroRutaSesion: number;
	};
	grupoKeyNoMember?: string | undefined;
	isRubrica?: IRubricaSegData;
}) {
	return useQuery(
		['estudianteData', estudianteKey, desafioCursoKey, grupoKeyNoMember],
		async (): Promise<{ estudiante: Estudiantes | undefined; desafioCurso: Desafios_Cursos | undefined }> => {
			// console.log('carga inicia lwow', isSeguimiento, isRubrica);
			const rutaEstudiante = `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/${estudianteKey}${
				cacheBust ? '?cacheBust=true' : ''
			}`;

			const rutaEstudianteInGuiaDigital = `${
				process.env.REACT_APP_NEST_BACKEND_URL
			}/estudiante/${estudianteKey}/${desafioCursoKey}/${cacheBust ? '?cacheBust=true' : ''}`;

			const rutaEstudianteSeg = isSeguimiento?.isSeguimiento
				? `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/seguimiento/${isSeguimiento.rutaKey}/${isSeguimiento.cursoKey}/${desafioCursoKey}/estudiante/${estudianteKey}/${isSeguimiento.tipoActividad}/${isSeguimiento.numeroSesion}/${isSeguimiento.numeroRutaSesion}`
				: isRubrica?.actividadEvaluacionKey
				? `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/seguimientoRubrica/${isRubrica.rutaKey}/${isRubrica.cursoKey}/${desafioCursoKey}/estudiante/${estudianteKey}/${isRubrica.tipoActividad}/${isRubrica.numeroSesion}/${isRubrica.actividadEvaluacionKey}`
				: '';

			const rutaEstudianteSegNoMember = isSeguimiento?.isSeguimiento
				? `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/seguimientoNoMember/${isSeguimiento.rutaKey}/${isSeguimiento.cursoKey}/${desafioCursoKey}/estudiante/${isSeguimiento.numeroSesion}/${grupoKeyNoMember}`
				: isRubrica?.actividadEvaluacionKey
				? `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/seguimientoRubrica/${isRubrica.rutaKey}/${isRubrica.cursoKey}/${desafioCursoKey}/estudiante/${grupoKeyNoMember}/${isRubrica.actividadEvaluacionKey}/${isRubrica.numeroSesion}/${isRubrica.actividadEvaluacionKey}`
				: '';

			const rutaHistorial = `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/historial/${estudianteKey}`;
			const rutaDesafioCurso = `${process.env.REACT_APP_NEST_BACKEND_URL}/desafio-curso/${desafioCursoKey}`;

			let endpoint;

			if (estudianteKey === 'null') {
				endpoint = rutaDesafioCurso;
				// } else if (isHistorialSeg) {
				// 	console.log('historialSeg???');
				// 	endpoint = rutaHistorial;
			} else if (isSeguimiento?.isSeguimiento || isRubrica?.actividadEvaluacionKey) {
				if (grupoKeyNoMember && (estudianteKey === undefined || estudianteKey === 'undefined')) {
					endpoint = rutaEstudianteSegNoMember;
				} else {
					endpoint = rutaEstudianteSeg;
				}
			} else if (estudianteKey === undefined) {
				endpoint = rutaEstudianteSeg;
			} else {
				if (desafioCursoKey) {
					endpoint = rutaEstudianteInGuiaDigital;
				} else {
					endpoint = rutaEstudiante;
				}
			}

			const { data } = await axios.get(endpoint);

			if (isSeguimiento?.isSeguimiento || isRubrica?.actividadEvaluacionKey) {
				return {
					estudiante: undefined,
					desafioCurso: data
				};
			}

			return {
				estudiante: estudianteKey !== 'null' ? data : undefined,
				desafioCurso: estudianteKey === 'null' ? data : undefined
			};
		},
		{
			refetchOnWindowFocus: false,
			enabled
		}
	);
}

export const fetchEstudianteHistorial = async (estudianteKey: string): Promise<Estudiantes> => {
	const resp = await axios.get(`${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/historial/${estudianteKey}`);
	return resp.data;
};

export const fetchDestudianteHistorialYears = async (estudianteKey: string): Promise<any> => {
	const resp = await axios.get(
		`${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/historial/year/${estudianteKey}`
	);
	return resp?.data?.data;
};

interface IGetEstudianteDetailQuery {
	key: string;
	nombre: string;
	apellido: string;
	password: string;
	email: string;
	firebase_uid: string;
	avatarPath: string;
	cambioPass: boolean;
	colegio: {
		key: string;
		pais: string;
		cursos: {
			idioma: string;
		}[];
	};
}

export const fetchGetEstudianteDetail = async (estudianteKey: string): Promise<IGetEstudianteDetailQuery> => {
	const isPWA =
		window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;
	const url = `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/detalle/${estudianteKey}${
		isPWA !== undefined ? `?isPWA=${isPWA}` : ''
	}`;
	const resp = await axios.get(url);
	return resp.data;
};
export const fetchEstudianteNotificaciones = async (estudianteKey: string): Promise<any> => {
	const resp = await axios.get(
		`${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/notificaciones/${estudianteKey}`
	);
	return resp.data;
};
